import { useSiteSettings } from '@/hooks/useSiteSettings';

/** Just Eat sipariş linki — site_settings.just_eat_url */
export function useJustEatUrl() {
  const { get, loading } = useSiteSettings();
  const url = get('just_eat_url', '').trim();
  return { url, hasUrl: url.length > 0, loading };
}
